import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { TripDetail } from './TripDetail';
import { toast, Toaster } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * TripDetailPage - Standalone trip detail view for /advisor/trips/:tripId
 * 
 * NOTE: HoV SpatialLayout dependency removed during STRUCTURE PASS.
 * This page now renders independently without HouseProvider context.
 */
export function TripDetailPage() {
  const { tripId } = useParams();
  const navigate = useNavigate();
  const [trip, setTrip] = useState(null);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tripRes, clientsRes] = await Promise.all([
          axios.get(`${API}/travels/trips/${tripId}`),
          axios.get(`${API}/clients`)
        ]);
        setTrip(tripRes.data);
        setClients(clientsRes.data || []);
      } catch (err) {
        setError(err.response?.data?.detail || 'Trip not found');
        toast.error('Failed to load trip');
      } finally {
        setLoading(false);
      }
    };

    if (tripId) {
      fetchData();
    }
  }, [tripId]);

  const handleBack = () => {
    navigate('/advisor');
  };

  const handleSave = () => {
    // Refresh trip data
    axios.get(`${API}/travels/trips/${tripId}`)
      .then(res => setTrip(res.data))
      .catch(() => {});
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F4]" data-testid="trip-detail-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#C5A059]" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F9F8F4]" data-testid="trip-detail-error">
        <Toaster position="top-right" richColors />
        <p className="text-[#B37E6B] mb-4">{error}</p>
        <button 
          onClick={handleBack}
          className="text-[#C5A059] hover:underline"
        >
          Return to Advisor Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F9F8F4]" data-testid="trip-detail-page">
      <TripDetail 
        trip={trip}
        clients={clients}
        onBack={handleBack}
        onSave={handleSave}
      />
    </div>
  );
}
